<!-- <div class="card mt-4">
  <h4 class="card-header">You're logged in with Angular 8 & Basic HTTP Authentication!!</h4>
  <div class="card-body">
    <h6>Users from secure api end point</h6>
    <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
    <ul *ngIf="users">
      <li *ngFor="let user of users">{{user.username}} {{user.roleName}}</li>
    </ul>
  </div>
</div> -->
<!-- <div class="row mt-4">
    <h2 class="col-xl-12 justify-content-center">{{greeting}}, {{currentUser?.username | titlecase}}</h2>
    <br>
    <span class="col-xl-12 justify-content-center text-center" style="font-size:small">{{day}}</span>
    <br>
    <span class="col-xl-12 justify-content-center text-center" style="font-size:small">Welcome back to SMS Dashboard.</span>
</div> -->

<div class="row mt-4">
  <h2 class="col-12">{{greeting}}, {{currentUser?.username | titlecase}}</h2>
  <br>
  <span class="col-12" style="font-size:small">{{day}}, Welcome back to IE Pay Dashboard.<a target="_blank" href="http://www.free-iqtest.net/">Survey</a> </span>
</div>
